/**
 * Radix modals (Dialog/Sheet) dismiss on any outside interaction, and some
 * layers legitimately live outside the modal's DOM subtree:
 * - floating voice call cards (`[data-floating-card]`, see
 *   `modules/voice/floating-card.tsx`) must stay usable while a modal is open,
 *   since the user may need to close the card or drag it out of the way
 * - select menus portaled to `document.body` (`[data-select-menu]`, see
 *   `components/ui/select-new.tsx`) belong to a control rendered inside the
 *   modal, so clicking an option must not close it
 *
 * Interactions with either must not count as "outside" dismissals.
 */
const PERSISTENT_LAYERS = "[data-floating-card], [data-select-menu]";

export function preventDismissOnDetachedLayer(event: {
  target: EventTarget | null;
  preventDefault: () => void;
}) {
  if (event.target instanceof Element && event.target.closest(PERSISTENT_LAYERS)) {
    event.preventDefault();
  }
}

/**
 * Escape should close an open select menu before it closes the modal around
 * it, so a stray keystroke never discards the form the menu belongs to. The
 * select handles the key itself; this only stops the modal from acting on the
 * same press.
 */
export function preventEscapeWhileSelectMenuOpen(event: { preventDefault: () => void }) {
  if (typeof document === "undefined") return;
  if (document.querySelector("[data-select-menu]")) {
    event.preventDefault();
  }
}
